import { useState } from "@wordpress/element";
import { Footer, Headers, Main, Notices } from "./components/_components";
const getInitialStateFromURLQuery = () => {
  const hash = window.location.hash.slice(1); // Remove the '#' at the start
  return hash;
};

const Dashboard = () => {
  const [currentTab, setTab] = useState(getInitialStateFromURLQuery);

  if (currentTab) {
    window.location.hash = currentTab;
    window.history.pushState({}, "", `#${currentTab}`);
  }
  return (
    <>
      <Headers isActive={currentTab} setActive={setTab} />
      <Main activeTab={currentTab} setActive={setTab} />
      <Footer />
      {undefined !== wp.notices.store && <Notices />}
    </>
  );
};

export default Dashboard;
